import {GeneralPaywallMeta} from '@7chairs/types';
import awards1 from '../../../../assets/awards1.svg';
import awards2 from '../../../../assets/awards2.svg';
import whiteCurvyEgg from '../../../../assets/whiteCurvyEgg.webp';
import {useWriteOnTextEffect} from '../../../../hooks/useWriteOnTextEffect';
import {Plan} from '../../../../types/plan';
import {DEFAULT_PLAN_KEY, PRICE_TEST_DEFAULT_PLAN_KEY, Variant} from '../../PickAProduct/PickAProduct.types';
import {ProductV2} from '../ProductV2';
import {
  PickPlanEggBg,
  PickPlanSectionAwardImg,
  PickPlanSectionAwards,
  PickPlanSectionContent,
  PickPlanSectionProducts,
  PickPlanSectionTitle,
  PickPlanSectionTitleNotVisible,
  PickPlanSectionTitleVisible,
  PickPlanSectionWrapper,
} from './PickAPlanSection.style';

interface PickPlanSectionProps {
  planPositions: string[];
  stripePlans: Record<string, Plan>;
  chosenPlanPosition: string | null;
  pickAProduct: (pp: string, id: string) => void;
  data: GeneralPaywallMeta;
  variant: Variant
}

export const PickPlanSection = (props: PickPlanSectionProps) => {
  const { planPositions, stripePlans, chosenPlanPosition, data, pickAProduct, variant } = props;

  const { text } = useWriteOnTextEffect({ finalText: data.title, delay: 50 });

  return (
    <PickPlanSectionWrapper>
      <PickPlanEggBg src={whiteCurvyEgg} alt="" />

      <PickPlanSectionTitle>
        <PickPlanSectionTitleVisible>{text}</PickPlanSectionTitleVisible>
        <PickPlanSectionTitleNotVisible>{data?.title}</PickPlanSectionTitleNotVisible>
      </PickPlanSectionTitle>

      <PickPlanSectionContent>
        <PickPlanSectionProducts>
          {planPositions.map((pp) => (
            <ProductV2
              key={stripePlans[pp].id}
              product={stripePlans[pp]}
              onClick={() => pickAProduct(pp, stripePlans[pp].id)}
              chosenPlanPosition={chosenPlanPosition ? chosenPlanPosition : variant === Variant.v1 ? DEFAULT_PLAN_KEY : PRICE_TEST_DEFAULT_PLAN_KEY}
            />
          ))}
        </PickPlanSectionProducts>

        <PickPlanSectionAwards>
          <PickPlanSectionAwardImg src={awards1} alt="awards1" />
          <PickPlanSectionAwardImg src={awards2} alt="awards2" />
        </PickPlanSectionAwards>
      </PickPlanSectionContent>
    </PickPlanSectionWrapper>
  );
};
